<template>
  <div class="matter-log">
    <el-radio-group class="switch" v-model="active" @change="handleClick">
      <el-radio-button v-if="getSite.hasInterim" label="1">{{$t('COMMON_INTERIM')}}</el-radio-button>
      <el-radio-button label="2">{{$t('COMMON_FINAL')}}</el-radio-button>
    </el-radio-group>
    <el-table v-show="active=='1'"
              :data="initData.interimMatterLogList"
              height="300px"
              v-loading="loading"
              border
              stripe
              @selection-change="handleSelectionChangeInterim"
              class="wl-table">
      <el-table-column type="selection"
                       width="40"></el-table-column>
      <el-table-column prop="title"
                       align="center"
                       width="100px"
                       show-overflow-tooltip
                       :label="$t('TABLE_HEADER_matter')">
      </el-table-column>
      <el-table-column prop="entityList"
                       align="center"
                       :label="$t('TABLE_HEADER_entityList')">
        <template slot-scope="scope">
                <span v-for="(item,index) in scope.row.entityList"
                      :key="index">
                  <span v-if="index==scope.row.entityList.length-1">{{item.entityName}}</span>
                  <span v-else>{{item.entityName}}/</span>
                </span>
        </template>
      </el-table-column>
      <el-table-column prop="category"
                       align="center"
                       width="130px"
                       :label="$t('TABLE_HEADER_category')">
      </el-table-column>
      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Issues')">

        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD001')">
          <el-dropdown>
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Deficiency')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD002')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Adjustment')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD003')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Difference')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD004')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-show="active=='2'"
              :data="initData.finalMatterLogList"
              height="300px"
              v-loading="loading"
              border
              stripe
              @selection-change="handleSelectionChangeFinal"
              class="wl-table">
      <el-table-column type="selection"
                       width="40"></el-table-column>
      <el-table-column prop="title"
                       align="center"
                       width="100px"
                       show-overflow-tooltip
                       :label="$t('TABLE_HEADER_matter')">
      </el-table-column>
      <el-table-column prop="entityList"
                       align="center"
                       :label="$t('TABLE_HEADER_entityList')">
        <template slot-scope="scope">
                <span v-for="(item,index) in scope.row.entityList"
                      :key="index">
                  <span v-if="index==scope.row.entityList.length-1">{{item.entityName}}</span>
                  <span v-else>{{item.entityName}}/</span>
                </span>
        </template>
      </el-table-column>
      <el-table-column prop="category"
                       align="center"
                       width="130px"
                       :label="$t('TABLE_HEADER_category')">
      </el-table-column>
      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Issues')">

        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD001')">
          <el-dropdown>
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Deficiency')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD002')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Adjustment')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD003')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column prop="typeDesc"
                       align="center"
                       :label="$t('TABLE_HEADER_Difference')">
        <template slot-scope="scope"
                  v-if="showIcon(scope.row,'MLTD004')">
          <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i :class="showStatus(scope.row)"
                       @click="toggleVisible(scope)"></i>
                  </span>
            <el-dropdown-menu class="wl-solt-menu-item"
                              slot="dropdown">
              <el-dropdown-item>

                <pop-hover :data="{row:scope.row,status:statusDict,priority:priority}"
                           :showBtn="false"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="checked-bottom">
      <el-checkbox v-model="clientModel">{{$t('PAGE_NEXTYEAR_CLIENT_TITLE')}}</el-checkbox>
      <el-checkbox v-model="KPMGModel">{{$t('PAGE_KPMG_TEAM_TITLE')}}</el-checkbox>
      <el-checkbox v-model="insights">{{$t('PAGE_NEXTYEAR_INSIGHT_TITLE')}}</el-checkbox>
    </div>
  </div>
</template>
<script>
    import API from '@/api';
    import PopHover from '@/views/client-view/matter-logs/pop-up';
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                active: '1',
                chooseStatus: [1, 2, 3],
                statusDict: [
                    {
                        value: 1,
                        label: 'dictionary_matterLog_status_being',
                        icon: 'fa fa-circle-o'
                    },
                    {
                        value: 2,
                        label: 'dictionary_matterLog_status_open',
                        icon: 'fa fa-times'
                    },
                    {
                        value: 3,
                        label: 'dictionary_matterLog_status_close',
                        icon: 'fa fa-check'
                    }
                ],
                priority: [],
                addOrEditVisible: false,
                current: {},
                siteId: '',
                chosenListInterim: [],
                chosenListFinal:[],
                insights: false,
                clientModel: false,
                KPMGModel: false,

            };
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getEntityIds: 'getEntityIds',
                getSite: 'getSite'
            })
        },
        methods: {
            handleSelectionChangeInterim(v) {
                this.chosenListInterim = v;
            },
            handleSelectionChangeFinal(v) {
                this.chosenListFinal = v;
            },
            getAuditType() {
                API.matterLogs.queryAuditType({}).then(res => {
                });
            },
            getPriority() {
                API.matterLogs.queryMatterLogPriority({}).then(res => {
                    if (res.code == '1') {
                        this.priority = res.data;
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                });
            },
            getMatterLogStatus() {
                API.matterLogs.queryMatterLogStatus({}).then(res => {
                    if (res.code == '1') {
                        this.statusDict = res.data;
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                });
            },
            toggleVisible({row}) {
                this.data = _.map(this.data, v => (v.id === row.id ? Object.assign(v, {visible: !v.visible}) : v));
            },
            handleClick() {
                this.onChangeAcitve(this.active)
            },
            onConfirm() {
                const chosenList = this.chosenListInterim.concat(this.chosenListFinal)
                this.onMatterList(
                    {
                        matter: _.map(chosenList, v => v.id),
                        insights: this.insights,
                        clientModel: this.clientModel,
                        KPMGModel: this.KPMGModel
                    });
            },
            onCurrentPageChange() {
            },
            selectFromLocal() {
                return Promise.resolve({
                    code: '1',
                    data: this.statusDict
                });
            },
            //是否显示
            showIcon(row, type) {
                return row.typeDesc == type;
            },
            //显示什么图标
            showStatus(row) {
                return _.filter(this.statusDict, v => v.value == row.matterStatus)[0].icon;
            }
        },
        mounted() {
            this.active = this.getSite.hasInterim ? '1' : '2';
            this.siteId = this.getSite.siteId;
            this.getAuditType();
            this.getMatterLogStatus();
            this.getPriority();
        },
        watch: {
            addOrEditVisible(visible) {
                if (!visible) {
                    //查表格的数据
                }
            }
        },
        components: {
            PopHover
        },
        props: {
            initData: {
                type: [Array, Object],
                default: []
            },
            onMatterList: {
                type: Function,
                default: () => {
                }
            },
            loading: Boolean,
            onChangeAcitve: {
                type: Function,
                default: () => {
                }
            },
        }
    };
</script>

<style scoped>
  .matter-log {
    padding: 0 10px;
    margin-top: -35px;
  }

  .wl-container .fa {
    font-size: 18px;
    cursor: pointer;
  }

  .switch {
    float: right;
    margin: 0 10px 10px 0;
  }

  .fa-circle-o,
  .wl-right > span:nth-child(1) {
    color: #49a2cf;
  }

  .fa-check,
  .wl-right > span:nth-child(3) {
    color: #6fbf0a;
  }

  .fa-times,
  .wl-right > span:nth-child(2) {
    color: #e60405;
  }

  .wl-right > span {
    padding: 0 12px;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    align-self: center;
  }

  .wl-right > span i {
    transform: translateY(-2px);
    margin-right: 6px;
  }

  .checked-bottom {
    margin: 35px 0 0 5px;
  }
</style>
